import React from 'react'
import Logo from "../../../../Reutilizables/Logo"
import MenuTasas from './MenuTasas'
import TituloImpuestosMunicipales from '../../../../Reutilizables/TituloImpuestosMunicipales'
import Redes from '../../../../Reutilizables/Redes'

function Peaje_turistico() {
  return (
    <>
      <div className='container-logo-menu'>
        <Logo />
        <MenuTasas />
      </div>
      <TituloImpuestosMunicipales />
      <Redes />
    </>
  )
}

export default Peaje_turistico